import { cn } from "@/lib/utils";

export const Marquee = ({ items, dark = false }) => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className={cn(
      "overflow-hidden border-y py-7",
      dark ? "border-white/10 bg-pine text-paper" : "border-black/10 bg-paper text-ink"
    )}
  >
    <div className="marquee-track flex w-max items-center whitespace-nowrap">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center pr-20 sm:pr-28">
          <span className="font-serif text-3xl italic tracking-tight sm:text-4xl">{item}</span>
          <span
            className={cn("ml-20 h-1.5 w-1.5 rounded-full sm:ml-28", dark ? "bg-clay" : "bg-clay")}
          />
        </span>
      ))}
    </div>
  </div>
);
